export const PANEL_CONFIG = {
    orderDetails: {
        detailKey: [
            'orderStatus', 'orderCloseValidation'
        ],
        label: 'Order',
        refreshLabel: 'Order Status',
        slideIndex: 0
    },
    // accountMemos: {
    //     detailKey: ['accountMemos'],
    //     label: 'Memos',
    //     refreshLabel: 'Memos',
    //     slideIndex: 1
    // },
    accountMemos: {
        detailKey: ['accountMemos'],
        label: 'Memos',
        refreshLabel: 'Memos',
        slideIndex: 1
    },
    packageDetails: {
        detailKey: [
            'packageDetails', 'billingDetails', 'collectionDetails', 'orderServices', 'equipmentOptions'
        ],
        label: 'Account',
        refreshLabel: 'Account',
        slideIndex: 2
    },
    equipmentDetails: {
        detailKey: ['equipmentDetails'],
        label: 'Equipment',
        refreshLabel: 'Equipment',
        slideIndex: 3
    },
    charges: {
        detailKey: ['charges'],
        label: 'Charges',
        refreshLabel: 'Charges',
        slideIndex: 4
    },
    justAskDetails: {
        detailKey: ['justAskDetails'],
        label: 'Just Ask',
        refreshLabel: 'Just Ask',
        slideIndex: 5
    }
};

export const SLIDE_CONFIG = {
    0: PANEL_CONFIG.orderDetails,
    1: PANEL_CONFIG.accountMemos,
    2: PANEL_CONFIG.packageDetails,
    3: PANEL_CONFIG.equipmentDetails,
    4: PANEL_CONFIG.charges,
    5: PANEL_CONFIG.justAskDetails
};



// WEBPACK FOOTER //
// ./src/constants/panelConfig.js